import Styles from '../MetaAdsAccountSetupModal.module.scss'
import { AccountAvatar } from 'components/PostPreviewModalV2/components/AccountToggle/AccountAvatar'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { ArrowRefresh2, Cursor04 } from 'blaze-ui/icons'
import { SuccessTag } from '../SuccessTag/SuccessTag'
import { MetaAdsAccountOverviewProps } from './Types'

export const MetaAdsAccountOverview = (props: MetaAdsAccountOverviewProps) => {
  const {
    facebookProfile,
    selectedAdAccount,
    selectedFacebookPage,
    selectedInstagramAccount,
    onConnectAdAccount,
    onConnectFacebookPage,
    onConnectInstagramAccount,
  } = props

  return (
    <div className={Styles.setupContainer}>
      <Text>
        Blaze automatically runs ads on your behalf using your Facebook and Instagram accounts. Connect your accounts
        below to get started. You'll only have to do this once.
      </Text>

      <div className={Styles.section}>
        <div className={Styles.sectionTitle}>Facebook Profile</div>
        <div className={Styles.card}>
          <div className={Styles.cardLeft}>
            <AccountAvatar account={facebookProfile} />
            <Text variant="primary" fontWeight="500">
              {facebookProfile.name}
            </Text>
          </div>
        </div>
      </div>

      <div className={Styles.section}>
        <div className={Styles.sectionTitle}>Ad Account</div>
        <div className={Styles.card}>
          <div className={Styles.cardLeft}>
            {selectedAdAccount ? (
              <div className={Styles.accountInfo}>
                <Text variant="primary" fontWeight="500">
                  {selectedAdAccount.name}
                </Text>

                <Text variant="secondary">
                  <div className={Styles.secondaryAccountInfo}>{`${
                    selectedAdAccount.additional_data.amount_spent ?? '0'
                  } ${selectedAdAccount.additional_data.currency ?? 'USD'} Spent`}</div>
                </Text>
              </div>
            ) : (
              <Text variant="secondary">Ad Account not connected</Text>
            )}
          </div>
          <div className={Styles.cardRight}>
            {selectedAdAccount ? (
              <>
                <Button variant="tertiary" size="sm" frontIcon={ArrowRefresh2} onPress={onConnectAdAccount}>
                  Switch Account
                </Button>
                <SuccessTag text="Connected" />
              </>
            ) : (
              <Button variant="ghost" size="lg" frontIcon={Cursor04} onPress={onConnectAdAccount}>
                Connect Ad Account
              </Button>
            )}
          </div>
        </div>
      </div>

      <div className={Styles.section}>
        <div className={Styles.sectionTitle}>Facebook Page</div>
        <div className={Styles.card}>
          <div className={Styles.cardLeft}>
            {selectedFacebookPage ? (
              <>
                <AccountAvatar
                  account={
                    {
                      account_type: 'page',
                      picture: selectedFacebookPage.picture,
                      name: selectedFacebookPage.name,
                      provider: 'facebook',
                    } as any
                  }
                />
                <div className={Styles.accountInfo}>
                  <Text variant="primary" fontWeight="500">
                    {selectedFacebookPage.name}
                  </Text>

                  <Text variant="secondary">
                    <div className={Styles.secondaryAccountInfo}>ID: {selectedFacebookPage.provider_id}</div>
                  </Text>
                </div>
              </>
            ) : (
              <Text variant="secondary">Page not selected</Text>
            )}
          </div>
          <div className={Styles.cardRight}>
            {selectedFacebookPage ? (
              <>
                <Button variant="tertiary" size="sm" frontIcon={ArrowRefresh2} onPress={onConnectFacebookPage}>
                  Switch Page
                </Button>
                <SuccessTag text="Connected" />
              </>
            ) : (
              <Button variant="ghost" size="lg" frontIcon={Cursor04} onPress={onConnectFacebookPage}>
                Select Page
              </Button>
            )}
          </div>
        </div>
      </div>

      <div className={Styles.section}>
        <div className={Styles.sectionTitle}>Instagram Account</div>
        <div className={Styles.card}>
          <div className={Styles.cardLeft}>
            {selectedInstagramAccount ? (
              <>
                <AccountAvatar
                  account={
                    {
                      account_type: 'page',
                      picture: selectedInstagramAccount.picture,
                      name: selectedInstagramAccount.name,
                      provider: 'instagram',
                    } as any
                  }
                />
                <div className={Styles.accountInfo}>
                  <Text variant="primary" fontWeight="500">
                    {selectedInstagramAccount.name}
                  </Text>

                  <Text variant="secondary">
                    <div className={Styles.secondaryAccountInfo}>ID: {selectedInstagramAccount.provider_id}</div>
                  </Text>
                </div>
              </>
            ) : (
              <Text variant="secondary">Instagram Account not connected</Text>
            )}
          </div>
          <div className={Styles.cardRight}>
            {selectedInstagramAccount ? (
              <>
                <Button variant="tertiary" size="sm" frontIcon={ArrowRefresh2} onPress={onConnectInstagramAccount}>
                  Switch Account
                </Button>
                <SuccessTag text="Connected" />
              </>
            ) : (
              <Button variant="ghost" size="lg" frontIcon={Cursor04} onPress={onConnectInstagramAccount}>
                Select Account
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
